var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSelection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "73.000000pt",
    height: "62.000000pt",
    viewBox: "0 0 73.000000 62.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,62.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 599 c0 -18 2 -19 15 -9 8 7 15 16 15 21 0 5 -7 9 -15 9 -9 0 -15 -9 -15 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491 330 c-98 -93 -183 -170 -187 -170 -5 0 -47 41 -94 92 -60 63 -90 89 -99 84 -9 -6 16 -37 90 -112 l103 -103 139 132 c76 73 164 155 195 183 36 32 52 53 44 58 -7 4 -82 -61 -191 -164z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelection);
export default __webpack_public_path__ + "static/media/selection.01e634d03c84e2238caaf6286835b0a4.svg";
export { ForwardRef as ReactComponent };